export class ArFeatureBaseModel {
    protected constructor() {}
}
